import { render, staticRenderFns } from "./Kiosk.vue?vue&type=template&id=e381cd40&scoped=true&lang=pug"
import script from "./Kiosk.vue?vue&type=script&lang=js"
export * from "./Kiosk.vue?vue&type=script&lang=js"
import style0 from "./Kiosk.vue?vue&type=style&index=0&id=e381cd40&prod&lang=scss"
import style1 from "./Kiosk.vue?vue&type=style&index=1&id=e381cd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e381cd40",
  null
  
)

export default component.exports